import React from 'react';
import '../../styles/ChartAnimations.css';
import './FolderChart.css';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import ExportButton from '../shared/ExportButton';

const FolderChart = ({ messages = [], filters = {}, compactView = false }) => {
  const safeMessages = Array.isArray(messages) ? messages : [];
  const { keyword, startDate, endDate } = filters;

  // Filter messages safely
  const filteredMessages = safeMessages.filter((msg) => {
    const tagsText = (msg.tags || []).join(',').toLowerCase();
    const timeVal = msg.time || msg.timestamp || msg.createdAt; // allow multiple field names

    if (keyword && !tagsText.includes(String(keyword).toLowerCase())) return false;

    if (startDate && timeVal) {
      if (new Date(timeVal) < new Date(startDate)) return false;
    }

    if (endDate && timeVal) {
      if (new Date(timeVal) > new Date(endDate)) return false;
    }

    return true;
  });

  // Generate folder counts
  const folderCounts = filteredMessages.reduce((acc, msg) => {
    const folder = msg.folder || msg.mailbox || 'Unknown';
    acc[folder] = (acc[folder] || 0) + 1;
    return acc;
  }, {});

  const data = Object.entries(folderCounts)
    .map(([folder, count]) => ({ name: folder, count }))
    .sort((a, b) => b.count - a.count);

  const chartHeight = compactView ? 200 : 300;
  const fontSize = compactView ? 10 : 14;
  const barSize = compactView ? 20 : 40;

    if (!safeMessages.length || !data.length) {
  return (
    <div
      id="folder-chart-container"
      className={`chart-container empty ${compactView ? 'compact' : 'full'}`}
    >
      <h3 id="folder-chart-title">📁 Messages by Folder</h3>

      <div className="chart-empty-body">
        <p className="empty-state">
          No data available yet.
        </p>
      </div>
    </div>
  );
}

  return (
    <div
      id="folder-chart-container"
      className={`chart-container ${compactView ? 'compact' : 'full'}`}
    >
      <h3 id="folder-chart-title">📁 Messages by Folder</h3>
      <p className="chart-summary">Total Messages: {filteredMessages.length}</p>
      <p className="chart-summary">Total Folders: {data.length}</p>

      <ExportButton
        data={data}
        filenameBase="folder-chart"
        containerId="folder-chart-container"
      />

      <ResponsiveContainer
        width="100%"
        height={chartHeight}
        aria-labelledby="folder-chart-title"
        role="img"
      >
        <BarChart
          data={data}
          margin={{ top: 10, right: 30, left: 0, bottom: 30 }}
          isAnimationActive={true}
          animationDuration={700}
          animationEasing="ease-out"
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" hide={compactView} tick={{ fontSize }} />
          <YAxis hide={compactView} allowDecimals={false} tick={{ fontSize }} />
          <Tooltip
            content={({ active, payload }) => {
              if (active && payload?.length) {
                const { name, count } = payload[0].payload;
                return (
                  <div className="custom-tooltip">
                    <p><strong>{name}</strong></p>
                    <p>Messages: {count}</p>
                  </div>
                );
              }
              return null;
            }}
          />
          <Bar
            dataKey="count"
            fill="var(--chart-primary, #6a4fc4)"
            barSize={barSize}
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FolderChart;